import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/Constants";
import {
  fetchMasterList,
  fetchMasterListById,
  addMasterRecord,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import Loader from "../../../../common/Loader";
import { toastFunc } from "../../../../components/common/util";
import IdleStatusConfirmForm from "./IdleStatusConfirmForm";
import { ErrorModal } from "../../../../components/common/errorModal";

const MachineStatus = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deptCode, setDeptCode] = useState();
  const [deptName, setDeptName] = useState();
  const [machinesData, setMachinesData] = useState();
  const [machineCode, setMachineCode] = useState();
  const [machineName, setMachineName] = useState();
  const [machineId, setMachineId] = useState();
  const [id, setId] = useState();
  const [idleReasonCode, setIdleReasonCode] = useState();
  const [idleReasonName, setIdleReasonName] = useState();
  const [confirmModel, setConfirmModel] = useState(false);
  const [currentIdleRecord, setCurrentIdleRecord] = useState();
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [jobcard, setJobcard] = useState();

  useEffect(() => {
    dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT)); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store
  const rowsData = masterList[Constants.MASTER.DEPARTMENT.name]?.data;
  let idleReasonList = useSelector(
    (state) =>
      state?.masterList?.page[Constants.TRANSACTION.MACHINEIDLEREASON.name]
        ?.data
  ); // User Details from Store

  useEffect(() => {
    if (!idleReasonList) {
      dispatch(fetchMasterList(Constants.TRANSACTION.MACHINEIDLEREASON));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idleReasonList]);

  const idleReasonResult =
    idleReasonList && idleReasonList.map(({ code, name }) => ({ code, name }));

  const navigateBack = () => {
    if (machineCode) {
      setMachineCode();
      setIdleReasonCode();
      setIdleReasonName();
      setDeptCode();
    } else if (!deptCode) {
      navigate("/home");
    } else {
      setDeptCode();
    }
  };

  const handleViewMachines = (departmentCode) => {
    let param = {};
    param.url = "getMasterListDataById";
    param.page = Constants.MASTER.MACHINES.name;
    param.id = departmentCode;

    if (departmentCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        setMachinesData(result?.payload?.data);
      });
    }
  };

  const fetchMachileIdleRecord = (machineCode) => {
    let param = {};
    param.url = "getMachineIdleList";
    param.page = Constants.TRANSACTION.MACHINEIDLEREASON.status_name;
    param.machineCode = machineCode;
    param.deptCode = deptCode;

    if (machineCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        setCurrentIdleRecord(result?.payload?.data);
        setIdleReasonCode(result?.payload?.data?.idleReasonCode);
        setIdleReasonName(result?.payload?.data?.idleReasonName);
        setId(result?.payload?.data?._id);
      });
    }
  };

  const handleCheck = (e) => {
    setIdleReasonCode(e.target.value);
    setIdleReasonName(e.target.id);
  };

  const resetError = () => {
    setIsError(false);
    setError("");
  };

  const handleSave = (remark, update = false) => {
    const idleReasonObj = {
      deptCode,
      deptName,
      machineCode,
      machineName,
      idleReasonCode,
      idleReasonName,
      machineId,
    };
    const param = { ...idleReasonObj };
    if (!update) {
      param.method = Constants.TRANSACTION.MACHINEIDLEREASON.ADD;
      param.idleRemark = remark;
    } else {
      param.method = Constants.TRANSACTION.MACHINEIDLEREASON.UPDATE;
      param.idleActiveRemark = remark;
      param.id = id;
    }
    param.edit = update;

    dispatch(addMasterRecord(param)).then((res) => {
      if (res?.payload?.status === 200) {
        if (!update) {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_trasaction.msg_idle_status.success_message"),
            2000
          );
        } else {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_trasaction.msg_idle_status.update_success_message"),
            2000
          );
        }
        dispatch(fetchMasterList(Constants.MASTER.MACHINES)); // userSlice store
        setConfirmModel(false);
        navigateBack();
      } else {
        setError(
          t("msg_trasaction.msg_idle_status.error_updating_machine_status")
        );
        setIsError(true);
        setConfirmModel(false);
        //toastFunc(Constants.MASTER.TOAST.error,t("msg_master_list.msg_department.invalid_input"),4000)
      }
    });
  };

  const headerMsg = t("msg_trasaction.msg_idle_status.page_title");

  return (
    <main className="generatejobcard main" id="main">
      <Card className="">
        <Card.Header>
          <Button
            type="button"
            variant="primary"
            className="btn btn-primary btn-xs navigateBackButton"
            onClick={() => navigateBack()}
          >
            <i class="bi bi-arrow-left back"> </i>
            <span className="back"> {t("msg_common.Back")}</span>
          </Button>

          <h5 className="machineStatusTitle"> {headerMsg}</h5>
          { machineCode && (<div className="submsgTitle">{t("msg_trasaction.msg_idle_status.machine") + machineCode + machineName}</div>)}
          { deptCode && (<div className="submsgTitle">{t("msg_trasaction.msg_idle_status.department") + deptCode+deptName}</div>)}
        </Card.Header>
        <Card.Body className="ps-3">
          <Row className="justify-center subContent">
            <Col xs={12} md={12} className="rightSide">
              <div className="rightSideInner timesheet">
                {isError && (
                  <ErrorModal
                    show={isError}
                    heading={t(
                      "msg_trasaction.msg_idle_status.error_updating_machine_status"
                    )}
                    bodyMessage={error}
                    onHide={() => {
                      resetError();
                    }}
                  ></ErrorModal>
                )}
                {machineCode ? (
                  <Row className="machineIdleLabel">
                    <Row>
                      <Col lg={4} md={4} sm={4} className="machineIdleColumn">
                        <div>
                          {t("msg_trasaction.msg_idle_status.department")}{" "}
                          {deptName && (
                            <span className="bg-table-status bg-table-new-status py-1 m-1">
                              {deptName}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col lg={4} md={4} sm={4} className="machineIdleColumn">
                        <div>
                          {t("msg_trasaction.msg_idle_status.batch_no")}
                          {jobcard && (
                            <span className="bg-table-status bg-table-new-status py-1 m-1">
                              {jobcard}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col lg={4} md={4} sm={4} className="machineIdleColumn">
                        <div>
                          {t("msg_trasaction.msg_idle_status.idle_from")}{" "}
                          {currentIdleRecord?.idleFrom && (
                            <span className="bg-table-status bg-table-new-status py-1 m-1">
                              {currentIdleRecord?.idleFrom}
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} className="machineIdleColumn">
                        <div>
                          {t("msg_trasaction.msg_idle_status.machine")}{" "}
                          {machineName && (
                            <span className="bg-table-status bg-table-new-status py-1 m-1">
                              {machineName}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col lg={4} md={4} sm={4} className="machineIdleColumn">
                        <div>
                          {t("msg_trasaction.msg_idle_status.present_status")}{" "}
                          {currentIdleRecord?.status && (
                            <span className="bg-table-status bg-table-new-status py-1 m-1">
                              {currentIdleRecord?.status}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col lg={4} md={4} sm={4} className="machineIdleColumn">
                        <div>
                          {t("msg_trasaction.msg_idle_status.idle_reason")}{" "}
                          {currentIdleRecord?.idleReasonName && (
                            <span className="bg-table-status bg-table-new-status py-1 m-1">
                              {currentIdleRecord?.idleReasonName}
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <br /> <br />
                    <hr />
                    <Row>
                      <Col>
                        <div>
                          <h4>
                            {t("msg_trasaction.msg_idle_status.idle_reason")}
                          </h4>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Form className="machine-status-form">
                        <Form.Group
                          as={Row}
                          name="rateType"
                          className="machineIdleRadio"
                          controlId="rateType"
                          onChange={(e) => handleCheck(e)}
                        >
                          {idleReasonResult &&
                            idleReasonResult.map((reason, index) => {
                              return (
                                <Col
                                  xs={12}
                                  md={4}
                                  key={index}
                                  className="machineIdleRadio"
                                >
                                  <Form.Check
                                    inline
                                    label={reason.name}
                                    name="rateType"
                                    type="radio"
                                    id={reason.name}
                                    value={reason.code}
                                    checked={idleReasonCode === reason.code}
                                  />
                                </Col>
                              );
                            })}
                        </Form.Group>
                      </Form>
                    </Row>
                    {confirmModel && (
                      <IdleStatusConfirmForm
                        show={confirmModel}
                        reset={currentIdleRecord?.status === "Idle"}
                        onHide={() => setConfirmModel(false)}
                        onConfirm={handleSave}
                      ></IdleStatusConfirmForm>
                    )}
                    <br />
                  </Row>
                ) : deptCode ? (
                  <Row>
                    <Loader
                      isLoading={!machinesData}
                      className={"text-center"}
                    />
                    {machinesData?.length > 0 ? (
                      machinesData?.map((value, index) => {
                        const statusInd =
                          value.status === Constants.MASTER.STATUS.Active;
                        return (
                          <Col
                            xs={12}
                            md={4}
                            className="commLeftRightPadding"
                            key={index}
                          >
                            <Card
                              className="machineStatus-card"
                              onClick={() => {
                                setMachineCode(value.machineCode);
                                fetchMachileIdleRecord(value.machineCode);
                                setMachineName(value.machineName);
                                setMachineId(value._id);
                                setJobcard(value?.jobcard);
                              }}
                            >
                              <div
                                className={
                                  statusInd
                                    ? "outline-primary card-body active"
                                    : "card-body in-active"
                                }
                              >
                                <div className="d-flex align-items-center">
                                  <div className="w-10 card-icon ">
                                    <i className="bi bi-tools label"></i>
                                  </div>
                                  <div className="machineStatus-text">
                                    {value.machineCode}: {value.machineName}
                                  </div>
                                  <div className="w-10 card-icon ">
                                    <i class="bi bi-chevron-double-right label"></i>
                                  </div>
                                </div>
                              </div>
                            </Card>
                          </Col>
                        );
                      })
                    ) : (
                      <div className="ps-3 ">
                        <h5>
                          {t("msg_trasaction.msg_idle_status.No_machine")}
                        </h5>
                      </div>
                    )}
                  </Row>
                ) : (
                  <Row>
                    <Loader isLoading={!rowsData} className={"text-center"} />
                    {rowsData?.length > 0
                      ? rowsData?.map((value, index) => {
                          const statusInd =
                            value.status === Constants.MASTER.STATUS.Active;
                          return (
                            <Col
                              xs={12}
                              md={4}
                              className="commLeftRightPadding"
                              key={index}
                            >
                              <Card
                                className="machineStatus-card"
                                onClick={() => {
                                  setDeptCode(value.deptCode);
                                  handleViewMachines(value.deptCode);
                                  setDeptName(value.deptName);
                                }}
                              >
                                <div
                                  className={
                                    statusInd
                                      ? "outline-primary card-body active"
                                      : "card-body in-active"
                                  }
                                >
                                  <div className="d-flex align-items-center">
                                    <div className="w-10 card-icon">
                                      <i className="bi bi-diagram-2-fill label"></i>
                                    </div>
                                    <div className="machineStatus-text">
                                      {value.deptCode}:{value.deptName}
                                    </div>
                                    <div className="w-10 ">
                                      <i class="bi bi-chevron-double-right label"></i>
                                    </div>
                                  </div>
                                </div>
                              </Card>
                            </Col>
                          );
                        })
                      : null}
                  </Row>
                )}
              </div>
            </Col>
          </Row>
        </Card.Body>
        {machineCode ? (
          <Card.Footer className="text-center machine-status-footer-button">
            <Button
              type="button"
              variant="warning"
              size="lg"
              className="btn btn-warning"
              disabled={!idleReasonCode || currentIdleRecord?.status === "Idle"}
              onClick={() => setConfirmModel(true)}
            >
              {t("msg_common.set_idle")}
            </Button>

            <Button
              type="button"
              variant="danger"
              size="lg"
              className="btn btn-danger"
              onClick={() => navigateBack()}
              data-dismiss="modal"
            >
              {t("msg_common.set_cancel")}
            </Button>

            <Button
              type="button"
              variant="success"
              size="lg"
              className="btn btn-success"
              disabled={currentIdleRecord?.status !== "Idle"}
              onClick={() => setConfirmModel(true)}
              data-dismiss="modal"
            >
              {t("msg_common.set_active")}
            </Button>
          </Card.Footer>
        ) : (
          ""
        )}
      </Card>
    </main>
  );
};

export default MachineStatus;
